module.exports = __webpack_public_path__ + "static/historico-tooltip-88bd3d5857651de506c938fc72bdc423.svg";